import { render, staticRenderFns } from "./publicDetail.vue?vue&type=template&id=1f6abe28&scoped=true&"
import script from "./publicDetail.vue?vue&type=script&lang=js&"
export * from "./publicDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaDetails.less?vue&type=style&index=0&id=1f6abe28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6abe28",
  null
  
)

component.options.__file = "publicDetail.vue"
export default component.exports